import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { AgGridReact } from 'ag-grid-react';
import ordinal from 'ordinal-js';
import ReactResizeDetector from 'react-resize-detector';
import ProgressBar from '../../../../components/progress-bar';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styles from './styles.css';
import Counter from '../../../../components/counter';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';
import OwnerCell from './OwnerCell';
import AmountCell from './AmountCell';
import RankingCell from './RankingCell';

class StatsCell extends Component {
  constructor() {
    super();
    this.state = {
      flip: false,
    };
    this.doFlip = this.doFlip.bind(this);
    this.onResizeContainer = this.onResizeContainer.bind(this);
    this.onResizeContainerBack = this.onResizeContainerBack.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading && !this.props.isLoading) {
      this.setState({ flip: false });
    }
  }
  
  onResizeContainer(width, height) {
    const { flip } = this.state;
    if (!flip) {
      this.setState({ width: Math.ceil(width) });
      this.props.onHeightChange(height);
      this.props.onWidthChange(Math.ceil(width));
    }
  }

  onResizeContainerBack(width, height) {
    const { flip } = this.state;
    if (flip) {
      this.setState({ width: Math.ceil(width) });
      this.props.onHeightChange(height);
      this.props.onWidthChange(Math.ceil(width));
    }
  }

  doFlip() {
    const { flip } = this.state;
    this.setState({ flip: !flip });
  }
  
  renderTable() {
    const {
      minHeight, rankings, title,
    } = this.props;
    const { flip, width } = this.state;
    if (!flip) {
      return null;
    }
    const amountWidth = 100;
    const rankWidth = 100;
    const columnDefs = [
      {
        headerName: title,
        field: 'owner',
        width: Math.max(0, width - amountWidth - rankWidth - 2),
        cellRenderer: OwnerCell,
        suppressMenu: true,
      },
      {
        headerName: 'Amount',
        field: 'amount',
        width: amountWidth,
        cellRenderer: AmountCell,
        type: 'numericColumn',
        suppressMenu: true,
      },
      {
        headerName: 'Ranking',
        field: 'ranking',
        width: rankWidth,
        cellRenderer: RankingCell,
        type: 'numericColumn',
        suppressMenu: true,
      },
    ];
    const headerHeight = 32;
    const topOptions = { alignedGrids: [], suppressHorizontalScroll: true, domLayout: 'autoHeight' };
    const bottomOptions = { alignedGrids: [], suppressHorizontalScroll: true, domLayout: 'autoHeight' };
    topOptions.alignedGrids.push(bottomOptions);
    bottomOptions.alignedGrids.push(topOptions);

    return (
      <div className={`${styles.rankTable} ag-theme-alpine`} style={{ height: minHeight, overflow: 'hidden' }}>
        
        <div style={{ height: headerHeight, width, overflow: 'hidden' }} >
          <AgGridReact
            reactNext
            enableColResize
            columnDefs={columnDefs}
            headerHeight={headerHeight}
            rowData={[]}
            gridOptions={topOptions}
          />
        </div>

        <div style={{ width, height: (minHeight - headerHeight), overflowX: 'hidden', overflowY: 'auto' }} >
          <AgGridReact
            reactNext
            enableColResize
            columnDefs={columnDefs}
            rowData={rankings}
            gridOptions={bottomOptions}
            suppressHorizontalScroll
            headerHeight="0"
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      title, rank, sumAmount,
      sumCount, children, minHeight,
      isLoading, rankings, sumCountOnClick, sumAmountOnClick,
      className, amountRate, countRate, hideCount, rateTitle,
      isRankingLoading,
    } = this.props;
    const { flip } = this.state;
    const cls = [styles.panel, 'panel', 'panel-default', 'animated', 'flipInX'];
    if (className) {
      cls.push(className);
    }
    if (flip) {
      cls.push(styles.flipped);
    }

    let rankingComp = (<div>&nbsp;</div>);
    if (!isRankingLoading) {
      rankingComp = (<span>Rankings <i className="fa fa-chevron-right" /></span>);
      if (rank !== null) {
        rankingComp = (<span>Ranking: <nobr>{rank}<sup>{ordinal.ordinalSuffix(rank)}</sup></nobr></span>);
      }
      const hasRankings = rankings.length > 0;
      if (rankings.length) {
        rankingComp = (
          <a
            href=""
            className="animated bounceIn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.doFlip();
            }}
          >
            {rankingComp}
          </a>
        );
      } else {
        rankingComp = (
          <div className="animated bounceIn">
            {rankingComp}
          </div>
        );
      }
    }
    
    let amountComp = null;
    let countComp = null;
    if (!isLoading) {
      if (sumAmount !== null) {
        amountComp = (
          <Counter value={sumAmount}>
            <MoneyDisplay value={0} abbreviated precision={1} />
          </Counter>
        );
        if (sumAmountOnClick !== null) {
          amountComp = (
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                sumAmountOnClick();
              }}
            >
              {amountComp}
            </a>
          );
        }
      } else {
        amountComp = (<span>N/A</span>);
      }
      if (!hideCount) {
        if (sumCount !== null) {
          countComp = (
            <Counter value={sumCount}>
              <NumberDisplay value={0} suffix="Deal" suffixIsUnit precision={0} />
            </Counter>
          );
          if (sumCountOnClick !== null) {
            countComp = (
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  sumCountOnClick();
                }}
              >
                {countComp}
              </a>
            );
          }
        } else {
          countComp = (<span>N/A</span>);
        }
      }
    }
    
    const amountTip = (
      <Tooltip id="amount-stats-popover">
        <div>
          Your {rateTitle} based on opportunity amounts
        </div>
      </Tooltip>
    );
    const countTip = (
      <Tooltip id="count-stats-popover">
        <div>
          Your {rateTitle} based on opportunity counts
        </div>
      </Tooltip>
    );

    return (
      <div className={cls.join(' ')}>
        <div className={`${styles.panelBody} animated slideInUp`}>
          <div className={styles.flipper}>
            <div className={styles.panelFront} style={{ minHeight }}>
              <ReactResizeDetector handleHeight handleWidth onResize={this.onResizeContainer} />
              <div className="panel-body">
                <div className="clearfix">
                  <h3 className="pull-left">{title}</h3>
                  {!isLoading &&
                    <h3 className={`${styles.rank} pull-right`}>
                      {rankingComp}
                    </h3>
                  }
                </div>
                {!isLoading &&
                  <div className="clearfix">
                    <div className="pull-left">
                      <div className={styles.counter}>
                        {amountComp}
                      </div>
                    </div>
                    <div className="pull-right text-right">
                      <div className={`${styles.counter} ${styles.subCounter}`}>
                        {countComp}
                      </div>
                    </div>
                  </div>
                }
                {!isLoading && (amountRate !== null || countRate !== null) &&
                  <div className={styles.rates}>
                    <div className="clearfix">
                      <div className="pull-left">
                        <div className={styles.rate}>
                          <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={amountTip}>
                            <div><span className={styles.rateNumber}><NumberDisplay value={amountRate} suffix="%" precision={1} /></span> Amount</div>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="pull-right text-right">
                        <div className={styles.rate}>
                          <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={countTip}>
                            <div><span className={styles.rateNumber}><NumberDisplay value={countRate} suffix="%" precision={1} /></span> Count</div>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              {!isLoading && children}
              {isLoading && <div className="panel-body"><ProgressBar /></div>}
            </div>
            {!isLoading &&
              <div className={styles.panelBack} style={{ minHeight }}>
                <ReactResizeDetector handleHeight handleWidth onResize={this.onResizeContainerBack} />
                <a
                  href=""
                  className={styles.close}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.doFlip();
                  }}
                >
                  <Fa name="times" />
                </a>
                {this.renderTable()}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

StatsCell.propTypes = {
  title: PropTypes.string.isRequired,
  sumAmount: PropTypes.number,
  sumCount: PropTypes.number,
  amountRate: PropTypes.number,
  countRate: PropTypes.number,
  rank: PropTypes.number,
  children: PropTypes.node,
  onHeightChange: PropTypes.func,
  onWidthChange: PropTypes.func,
  minHeight: PropTypes.number,
  isLoading: PropTypes.bool,
  rankings: PropTypes.arrayOf(PropTypes.shape({})),
  isRankingLoading: PropTypes.bool,
  sumCountOnClick: PropTypes.func,
  sumAmountOnClick: PropTypes.func,
  className: PropTypes.string,
  hideCount: PropTypes.bool,
  rateTitle: PropTypes.string,
};
StatsCell.defaultProps = {
  sumAmount: null,
  sumCount: null,
  amountRate: null,
  countRate: null,
  minHeight: 0,
  isLoading: true,
  children: null,
  onHeightChange: () => {},
  onWidthChange: () => {},
  rankings: [],
  rank: null,
  isRankingLoading: true,
  sumCountOnClick: null,
  sumAmountOnClick: null,
  className: null,
  hideCount: false,
  rateTitle: null,
};

export default StatsCell;
